import React from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import {
  FontWeightType, LabelLarge, LabelMedium, LabelSmall, TitleMedium,
} from '../../../../component/Text';
import { useMobile } from '../../../../hook/usePlatform';
import { MainButton } from '../../../../component/button';

interface ModalType {
  visible:boolean,
  setVisible:(visible:boolean)=>void,
}
const PasswordChangeCompleteModal : React.FC<ModalType> = ({ visible, setVisible }) => {
  const isMobile = useMobile();
  const navigate = useNavigate();
  const resetToLogin = async () => {
    setVisible(false);
    await navigate('/login', { replace: true });
  };
  return (
    <Modal
      isOpen={visible}
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          border: '',
          backgroundColor: 'transparent',
        },
      }}
      onRequestClose={() => {
        setVisible(false);
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >

        <div style={{
          paddingBlock: 32,
          width: isMobile ? '80%' : '50%',
          paddingInline: isMobile ? 10 : 100,
          backgroundColor: 'white',
        }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              marginBottom: 16,
            }}
          >
            <TitleMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w800}>비밀번호 변경 완료!</TitleMedium>
            <LabelMedium style={{ fontFamily: 'inter', marginTop: 16 }}>
              비밀번호가 변경되었습니다.
            </LabelMedium>
            <LabelMedium style={{ fontFamily: 'inter' }}>
              안전하게 다시 로그인 해주세요!
            </LabelMedium>
          </div>
          <MainButton text="확인" onPress={resetToLogin} style={{ width: '100%' }} />
        </div>
      </div>
    </Modal>
  );
};
export default PasswordChangeCompleteModal;
